/**
 *
 * @param {*} msgChatPost
 * @returns
 */
export const renderStatusSendMsgError = (msgChatPost) => {
    if (msgChatPost?.insertFail) {
        return (
            <div className="div-msg-chat-fail">
                <span className="spMsgFail">Failed to send. </span>
                <span className="btnOption-chat-fail" role="button">
                    Resend
                </span>
                {' or '}
                <span className="btnOption-chat-fail" role="button">
                    delete
                </span>
                ?
            </div>
        );
    }
    return null;
};